import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  TabPanels,
} from "@headlessui/react";
import React from "react";
import { IoMdClose } from "react-icons/io";

const LoadWallet = ({
  isOpen,
  onClose,
  amount,
  setAmount,
  handleMakePayment,
  isLoadingLoadWallet,
  selectedIndex,
  setSelectedIndex,
}) => {
  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg sm:max-w-md md:max-w-lg">
              <div className="bg-[#21140E0F] px-3 pb-4 pt-3 sm:px-4">
                <div className="flex justify-between items-center mb-3">
                  <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                    Load Wallet
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="text-[#1C2024] p-1.5 rounded-full"
                  >
                    <IoMdClose className="text-xl sm:text-2xl" />
                  </button>
                </div>

                <div>
                  <div className="grid grid-cols-1 gap-4">
                    <TabGroup
                      selectedIndex={selectedIndex}
                      onChange={setSelectedIndex}
                    >
                      <TabList className="flex gap-4">
                        <Tab
                          className={
                            "rounded-full py-1 px-3 text-sm/6 font-semibold bg-white text-[#284184] focus:outline-none " +
                            "data-[selected]:bg-[#284184] data-[selected]:text-white " +
                            "data-[hover]:bg-[#284184]/20 data-[selected]:data-[hover]:bg-[#284184]"
                          }
                        >
                          Increase
                        </Tab>
                        <Tab
                          className={
                            "rounded-full py-1 px-3 text-sm/6 font-semibold bg-white text-[#284184] focus:outline-none " +
                            "data-[selected]:bg-[#284184] data-[selected]:text-white " +
                            "data-[hover]:bg-[#284184]/20 data-[selected]:data-[hover]:bg-[#284184]"
                          }
                        >
                          Decrease
                        </Tab>
                      </TabList>
                      <div className="rounded-xl content-center text-center mt-3">
                        <input
                          type="number"
                          id="card-number"
                          className="border border-gray-300 rounded-md px-3 py-2 w-full"
                          placeholder="Enter Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                      </div>
                      <TabPanels>
                        <TabPanel>
                          <div className="grid grid-cols-2 gap-4 mt-3">
                            <button
                              className={`px-4 py-2 rounded-md ${
                                amount === 50
                                  ? "bg-[#E9F2FF] text-[#284184] border border-[#CBE1FF]"
                                  : "bg-white"
                              }`}
                              onClick={() => setAmount(50)}
                            >
                              $50
                            </button>
                            <button
                              className={`px-4 py-2 rounded-md ${
                                amount === 100
                                  ? "bg-[#E9F2FF] text-[#284184] border border-[#CBE1FF]"
                                  : "bg-white"
                              }`}
                              onClick={() => setAmount(100)}
                            >
                              $100
                            </button>
                            <button
                              className={`px-4 py-2 rounded-md ${
                                amount === 150
                                  ? "bg-[#E9F2FF] text-[#284184] border border-[#CBE1FF]"
                                  : "bg-white"
                              }`}
                              onClick={() => setAmount(150)}
                            >
                              $150
                            </button>
                            <button
                              className={`px-4 py-2 rounded-md ${
                                amount === 200
                                  ? "bg-[#E9F2FF] text-[#284184] border border-[#CBE1FF]"
                                  : "bg-white"
                              }`}
                              onClick={() => setAmount(200)}
                            >
                              $200
                            </button>
                          </div>
                        </TabPanel>
                      </TabPanels>
                    </TabGroup>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 pt-4">
                  <button
                    type="button"
                    onClick={onClose}
                    className="w-full rounded-md border font-semibold border-[#F04438] bg-white px-4 py-2 text-sm text-[#F04438] hover:bg-red-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-full rounded-md border font-semibold border-transparent bg-[#284184] px-4 py-2 text-sm text-white hover:bg-[#1f3266] transition-colors"
                    onClick={() => handleMakePayment(String(amount))}
                    disabled={isLoadingLoadWallet}
                  >
                    {isLoadingLoadWallet
                      ? "Loading..."
                      : selectedIndex !== 0
                      ? "Update"
                      : `Load $ ${amount}`}
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default LoadWallet;
